<template>
  <header :style="{ background : 'url(' + image_path + ') left ' + position  + ' / cover' }">
    <div class="overlay"></div>
    <div class="container h-100">
      <div class="d-flex h-100 align-items-center">
        <div class="w-100 text-white">
          <h1 class="display-1 text-uppercase text-bold">{{title}}</h1>
          <span class="lead desc">{{description}}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "header_slide",
  props: ["title", "description", "image_path", "position"]
};
</script>

<style lang="scss" scoped>
header {
  position: relative;
  height: 60vh;
  min-height: 25rem;
  width: 100%;
  overflow: hidden;
  
  
  .container {
    position: relative;
    z-index: 2;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #063959;
    opacity: 0.5;
    z-index: 1;
    display: none;
  }

  .align-items-center {
    text-align: center;
  }

  h1 {
    font-family: "Nunito", serif;
    font-size: 45px;
    line-height: 1.5;
    font-weight: 600;
    letter-spacing: 1px;
  }

  span.desc {
    font-weight: 400;
    font-size: 25px;
    line-height: 1.6;
  }
}
</style>